import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'
import MenuItem from '@material-ui/core/MenuItem'
import MenuList from '@material-ui/core/MenuList'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import Paper from '@material-ui/core/Paper'
import Grow from '@material-ui/core/Grow'
import Hidden from '@material-ui/core/Hidden'
import Popper from '@material-ui/core/Popper'

// @material-ui/icons
import Person from '@material-ui/icons/Person'
import ContactSupportIcon from '@material-ui/icons/ContactSupport'
import DashboardIcon from '@material-ui/icons/Dashboard'

// core components
import Button from 'components/CustomButtons/Button.js'

import styles from 'assets/jss/material-dashboard-pro-react/components/adminNavbarLinksStyle.js'
import { Tooltip } from '@material-ui/core'

const useStyles = makeStyles(styles)

export default function HeaderLinks(props) {
  const history = useHistory()
  const [openProfile, setOpenProfile] = React.useState(null)
  const handleClickProfile = event => {
    if (openProfile && openProfile.contains(event.target)) {
      setOpenProfile(null)
    } else {
      setOpenProfile(event.currentTarget)
    }
  }
  const handleCloseProfile = () => {
    setOpenProfile(null)
  }
  const classes = useStyles()
  const { rtlActive } = props
  const dropdownItem = classNames(classes.dropdownItem, classes.primaryHover, {
    [classes.dropdownItemRTL]: rtlActive
  })
  const wrapper = classNames({
    [classes.wrapperRTL]: rtlActive
  })
  const managerClasses = classNames({
    [classes.managerClasses]: true
  })

  const userInfo = JSON.parse(localStorage.getItem('userInfo'))
  return (
    <div className={wrapper}>
      <div className={managerClasses}>
        <div
          style={{
            display: 'inline',
            paddingRight: '12px'
          }}
        >
          <strong>{userInfo.metadata.tenantId}</strong>
        </div>
        <Tooltip title="Home">
          <Button
            color="transparent"
            justIcon
            aria-owns={openProfile ? 'profile-menu-list' : null}
            aria-haspopup="true"
            onClick={() => history.push('/admin/home')}
            className={rtlActive ? classes.buttonLinkRTL : classes.buttonLink}
            muiClasses={{
              label: rtlActive ? classes.labelRTL : ''
            }}
          >
            <DashboardIcon
              className={
                classes.headerLinksSvg +
                ' ' +
                (rtlActive ? classes.links + ' ' + classes.linksRTL : classes.links)
              }
            />
            <Hidden mdUp implementation="css">
              <span onClick={handleClickProfile} className={classes.linkText}>
                {'Home'}
              </span>
            </Hidden>
          </Button>
        </Tooltip>
        <Tooltip title="Support">
          <Button
            color="transparent"
            justIcon
            aria-owns={openProfile ? 'profile-menu-list' : null}
            aria-haspopup="true"
            onClick={() => window.open('https://landing.relishiq.com/tickets-view', '_blank')}
            className={rtlActive ? classes.buttonLinkRTL : classes.buttonLink}
            muiClasses={{
              label: rtlActive ? classes.labelRTL : ''
            }}
          >
            <ContactSupportIcon
              className={
                classes.headerLinksSvg +
                ' ' +
                (rtlActive ? classes.links + ' ' + classes.linksRTL : classes.links)
              }
            />
            <Hidden mdUp implementation="css">
              <span onClick={handleClickProfile} className={classes.linkText}>
                {'Support'}
              </span>
            </Hidden>
          </Button>
        </Tooltip>
        <Button
          color="transparent"
          aria-label="Person"
          justIcon
          aria-owns={openProfile ? 'profile-menu-list' : null}
          aria-haspopup="true"
          onClick={handleClickProfile}
          className={rtlActive ? classes.buttonLinkRTL : classes.buttonLink}
          muiClasses={{
            label: rtlActive ? classes.labelRTL : ''
          }}
        >
          <Person
            className={
              classes.headerLinksSvg +
              ' ' +
              (rtlActive ? classes.links + ' ' + classes.linksRTL : classes.links)
            }
          />
          <Hidden mdUp implementation="css">
            <span onClick={handleClickProfile} className={classes.linkText}>
              {'Profile'}
            </span>
          </Hidden>
        </Button>
        <Popper
          open={Boolean(openProfile)}
          anchorEl={openProfile}
          transition
          disablePortal
          placement="bottom"
          className={classNames({
            [classes.popperClose]: !openProfile,
            [classes.popperResponsive]: true,
            [classes.popperNav]: true
          })}
        >
          {({ TransitionProps }) => (
            <Grow {...TransitionProps} id="profile-menu-list" style={{ transformOrigin: '0 0 0' }}>
              <Paper className={classes.dropdown}>
                <ClickAwayListener onClickAway={handleCloseProfile}>
                  <MenuList role="menu">
                    <MenuItem onClick={props.signOut} className={dropdownItem}>
                      Log out
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </div>
  )
}

HeaderLinks.propTypes = {
  rtlActive: PropTypes.bool
}
